module.exports = __webpack_public_path__ + "img/at-work.9a2945b8.png";